import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dialog: {
    minHeight: '300px !important',
    [theme.breakpoints.up('md')]: {
      maxWidth: '650px !important'
    }
  },
  question: {
    marginTop: theme.spacing(2)
  },
  buttonsContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(7),
    justifyContent: 'center'
  },
  button: {
    width: 200,
    height: 40,
    borderRadius: 10
  }
}))
